<template>
  <section id="section__ready-service">
    <StaticGuide>
      <template #contents>
        <v-row no-gutters class="py-8">
          <v-col cols="12" class="text-center" style="margin-bottom: 3rem">
            <img src="@/assets/images/guide/servicecong.png" alt="폭죽 펑펑" />
          </v-col>

          <v-col cols="12" class="text-center">
            <p class="mb-1 font--m-3 font-weight-bold">서비스 이용을 위한 모든 준비가 끝났어요!!</p>
            <p class="mb-1 font--m-3 font-weight-bold">상담사가 연락 드려 안내 드릴 예정이에요</p>
            <p class="font--m-3 font-weight-bold">잠시만 기다려 주세요</p>
          </v-col>
        </v-row>
      </template>

      <template #activator>
        <v-row no-gutters>
          <v-col cols="12">
            <BasicButton @click="close()"> 닫기 </BasicButton>
          </v-col>
        </v-row>
      </template>
    </StaticGuide>
  </section>
</template>
<script>
import { closeBrowser } from '@/util'
import StaticGuide from '@/components/common/guide/StaticGuide.vue'

export default {
  components: {
    StaticGuide,
  },
  methods: {
    close() {
      closeBrowser()
    },
  },
}
</script>
